import { render, staticRenderFns } from "./UserProfileViewComments.vue?vue&type=template&id=25b6b29a&"
import script from "./UserProfileViewComments.vue?vue&type=script&lang=js&"
export * from "./UserProfileViewComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports